import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Image, Button } from "react-bootstrap";
import Switch from "react-switch";
import moment from "moment";
import isEmpty from "../../../../../store/validation/is-Empty";
import { MERCHANT_PROMOTION_STATUS } from "../../../../../enums/GlobalEnums";
import EditMerchantPromotionRequest from "../EditMerchantPromotionRequest";

export const PromotionTableBody = (props) => {
  let history = useHistory();
  const [TrDetail, setTrDetail] = useState(false);
  const businessType = useSelector((state) => {
    return !isEmpty(state.category) ? state.category.restaurant_type : [];
  });

  let defaultColor = "#6d5ae7";
  let colorData = props?.restaurantTagsData.filter(function (el) {
    return el.name === props.promotion?.tag;
  });

  return (
    <tbody className="w-100 super-admin-all-vendor-main-table-body">
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css text-break">
              <tr
                onClick={() => setTrDetail(!TrDetail)}
                className={
                  props.displayActions
                    ? `py-3 ${props?.index % 2 === 0 && `disabled`}`
                    : `py-3`
                }
                // table-body-left-vertical-badge
                style={{
                  border: "none",
                  borderRadius: "5px 0px 0px 5px",
                  borderLeft: props.displayCss
                    ? `1.0708vw solid ${
                        colorData[0] !== undefined && colorData[0] !== null
                          ? colorData[0]?.hexColor
                          : defaultColor
                      }`
                    : "0vw solid transparent",
                }}
              >
                {props.displayActions ? (
                  <td
                    style={{ width: "2%" }}
                    className="table-body-left-vertical-badge-td"
                  >
                    <div className="f9-500" style={{ letterSpacing: 1 }}>
                      {props.promotion?.tag.toUpperCase()}
                    </div>
                  </td>
                ) : (
                  ""
                )}
                <td
                  className="text-break"
                  style={{ width: `${props.displayCss ? "9%" : "10%"}` }}
                >
                  <div className="ml-3">
                    <Image
                      src={
                        !isEmpty(
                          props.promotion?.restaurant_id?.logo_url_thumbnails
                        )
                          ? props.promotion?.restaurant_id?.logo_url_thumbnails
                          : require("../../../../../assets/images/ActionImages/demoprofile.jpg")
                      }
                      alt={"Restaurant Logo"}
                      title={"Restaurant Logo"}
                      fluid
                      className="img-thumbnail h-auto w-50 mb-2"
                    />
                    <div className="f10-500">
                      #{props.promotion?.restaurant_id?._id}
                    </div>{" "}
                  </div>
                </td>
                <td style={{ width: `${props.displayCss ? "11%" : "12%"}` }}>
                  <h5 className="f14-500">
                    {props.promotion?.restaurant_id?.restaurant_name}
                  </h5>
                </td>
                <td style={{ width: `${props.displayCss ? "15%" : "20%"}` }}>
                  {!isEmpty(props.promotion?.restaurant_id?.point_of_contact) &&
                    props.promotion?.restaurant_id?.point_of_contact.map(
                      (contact, index) => {
                        return contact?.defaultChecked === true ? (
                          <React.Fragment key={index}>
                            <h5 className="f12-500">
                              {contact?.firstName + " " + contact?.lastName}
                            </h5>
                            <h5 className="f12-500">
                              {!isEmpty(contact?.enquiry_emails) &&
                                contact?.enquiry_emails.map((email, index) => {
                                  if (index === 0) {
                                    return email;
                                  } else if (email) {
                                    return ", " + email;
                                  }
                                })}
                            </h5>
                            <h5 className="f12-500">
                              {!isEmpty(contact?.phone_numbers) &&
                                contact?.phone_numbers.map((phone, index) => {
                                  if (index === 0) {
                                    return (
                                      phone?.country_code +
                                      " " +
                                      phone?.mobile_no
                                    );
                                  } else if (
                                    phone?.country_code +
                                    " " +
                                    phone?.mobile_no
                                  ) {
                                    return (
                                      ", " +
                                      phone?.country_code +
                                      " " +
                                      phone?.mobile_no
                                    );
                                  }
                                  return (
                                    <React.Fragment>
                                      {!isEmpty(phone) &&
                                        phone?.country_code +
                                          " " +
                                          phone?.mobile_no}
                                    </React.Fragment>
                                  );
                                })}
                            </h5>
                          </React.Fragment>
                        ) : null;
                      }
                    )}
                </td>
                <td style={{ width: `${props.displayCss ? "10%" : "10%"}` }}>
                  <h5 className="f12-500">
                    {props.promotion?.restaurant_id?.city}
                  </h5>
                  <h5 className="f12-500">
                    {props.promotion?.restaurant_id?.area}
                  </h5>
                  <h5 className="f12-500">
                    {props.promotion?.restaurant_id?.pinCode}
                  </h5>
                </td>
                <td style={{ width: `${props.displayCss ? "10%" : "10%"}` }}>
                  <h5 className="f12-500">
                    {businessType &&
                      businessType.map((data) => {
                        return data?._id ===
                          props.promotion?.restaurant_id
                            ?.primary_restaurant_type
                          ? data?.title
                          : null;
                      })}
                  </h5>
                </td>
                <td style={{ width: `${props.displayCss ? "15%" : "12%"}` }}>
                  {props.displayActions ? (
                    parseInt(props?.promotion?.status) === 0 ? (
                      ""
                    ) : (
                      <div>
                        <h5 className="f12-500 mb-1">
                          {moment(props?.promotion?.start_date).format(
                            "Do MMM YYYY, hh:mm A"
                          )}
                        </h5>
                        <h5 className="f12-500" style={{ color: "#EE3A23" }}>
                          {moment(props?.promotion?.end_date).format(
                            "Do MMM YYYY, hh:mm A"
                          )}
                        </h5>
                      </div>
                    )
                  ) : (
                    <div className="f12-500">
                      {props.promotion?.permotion_type}
                    </div>
                  )}
                </td>
                <td style={{ width: `${props.displayCss ? "11%" : "12%"}` }}>
                  {props.displayActions
                    ? MERCHANT_PROMOTION_STATUS &&
                      MERCHANT_PROMOTION_STATUS.map((data, index) => {
                        return data.id ===
                          parseInt(props?.promotion?.status) ? (
                          <div
                            className={`px-3 py-1 badge f10-400`}
                            style={{
                              fontWeight: 400,
                              borderRadius: 25,
                              backgroundColor: data?.color,
                              color:
                                parseInt(props?.promotion?.status) === 0 ||
                                parseInt(props?.promotion?.status) === 4
                                  ? "#212121"
                                  : "#FFFFFF",
                            }}
                            key={index}
                          >
                            {data?.title}
                          </div>
                        ) : null;
                      })
                    : !isEmpty(props?.restaurantTagsData) &&
                      props?.restaurantTagsData.map((data, index) => {
                        return props.promotion?.tag === data.name ? (
                          <div
                            className="px-3 py-1 badge f10-500"
                            style={{
                              fontWeight: 400,
                              borderRadius: 25,
                              backgroundColor: `${data?.hexColor}`,
                              color: "#ffffff",
                            }}
                            key={index}
                          >
                            {data?.name}
                          </div>
                        ) : null;
                      })}
                </td>
                <td
                  style={{ width: `${props.displayCss ? "6%" : "14%"}` }}
                  onClick={(e) => {
                    if (!e) var e = window.event;
                    e.cancelBubble = true;
                    if (e.stopPropagation) e.stopPropagation();
                  }}
                >
                  {props.displayActions ? (
                    <Switch
                      checked={
                        props.promotion?.restaurant_id?.tagDetails?.status ===
                          "APPROVED" &&
                        props.promotion?.restaurant_id?.restaurantTag ===
                          props?.promotion?._id
                          ? true
                          : false
                      }
                      onChange={props.onToggleButtonClick}
                      // offColor="#EEEEEE"
                      onColor="#EEEEEE"
                      offHandleColor="#212121"
                      onHandleColor="#59F832"
                      handleDiameter={24} //19
                      uncheckedIcon={false}
                      checkedIcon={false}
                      offColor="#bcbcbc"
                      boxShadow="-2px 0px 5px #0000003B"
                      activeBoxShadow="-2px 0px 5px #0000003B"
                      height={15} //22
                      width={41} //45
                      id="disabled-switch"
                      disabled={
                        parseInt(props.promotion?.status) === 1 &&
                        history.location.pathname.includes(
                          "/superadmin/merchant-approve-tags"
                        )
                          ? false
                          : true
                      }
                    />
                  ) : (
                    MERCHANT_PROMOTION_STATUS &&
                    MERCHANT_PROMOTION_STATUS.map((data, index) => {
                      return data.id === parseInt(props?.promotion?.status) ? (
                        <div
                          className={`px-3 py-1 badge f10-500`}
                          style={{
                            fontWeight: 400,
                            borderRadius: 25,
                            backgroundColor: data?.color,
                            color:
                              parseInt(props?.promotion?.status) === 0 ||
                              parseInt(props?.promotion?.status) === 4
                                ? "#212121"
                                : "#FFFFFF",
                          }}
                          key={index}
                        >
                          {data?.title}
                        </div>
                      ) : null;
                    })
                  )}
                </td>
                {/* {console.log(
                  "history.location.pathname ===>",
                  history.location.pathname
                )} */}
                {props.displayActions ? (
                  <td
                    style={{ width: "12%" }}
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                    }}
                  >
                    {parseInt(props.promotion?.status) === 0 &&
                    history.location.pathname.includes(
                      "/superadmin/merchant-maintain-tags"
                    ) ? (
                      <div
                        className="btn f12-400 p-2 bg-white"
                        style={{
                          border: "2px solid #EE3A23",
                          boxShadow: "0px 3px 6px #6E6E6E21",
                          borderRadius: "5px",
                          color: "#000000",
                        }}
                        onClick={props.assignTags}
                      >
                        Assign Tag
                      </div>
                    ) : (parseInt(props.promotion?.status) === 1 ||
                        parseInt(props.promotion?.status) === 2 ||
                        parseInt(props.promotion?.status) === 3 ||
                        parseInt(props.promotion?.status) === 4 ||
                        parseInt(props.promotion?.status) === 5) &&
                      history.location.pathname.includes(
                        "/superadmin/merchant-maintain-tags"
                      ) ? (
                      <div
                        className="btn f12-400 p-2 disabled"
                        style={{
                          border: "2px solid #E0E0E0",
                          boxShadow: "0px 3px 6px #6E6E6E21",
                          borderRadius: "5px",
                          color: "#E0E0E0",
                        }}
                        // onClick={props.assignTags}
                      >
                        Assign Tag
                      </div>
                    ) : parseInt(props.promotion?.status) === 4 &&
                      history.location.pathname.includes(
                        "/superadmin/merchant-validate-tags"
                      ) ? (
                      <div className="d-flex align-items-center justify-content-center">
                        <div
                          className="mr-3 f10-500"
                          align="center"
                          onClick={props.rejectClick}
                        >
                          <Image
                            src={require("../../../../../assets/images/iconButton/crossred.svg")}
                            alt="Reject"
                            title="Reject"
                          />
                          Reject
                        </div>
                        <div
                          className="mr-3 f10-500"
                          align="center"
                          onClick={props.validateClick}
                        >
                          <Image
                            src={require("../../../../../assets/images/iconButton/Nextarrowgreen.svg")}
                            alt="Validate"
                            title="Validate"
                          />
                          Validate
                        </div>
                      </div>
                    ) : parseInt(props.promotion?.status) === 3 &&
                      history.location.pathname.includes(
                        "/superadmin/merchant-approve-tags"
                      ) ? (
                      <div className="d-flex align-items-center justify-content-center">
                        <div
                          className="mr-3 f10-500"
                          align="center"
                          onClick={props.cancelClick}
                        >
                          <Image
                            src={require("../../../../../assets/images/iconButton/crossred.svg")}
                            alt="Reject"
                            title="Reject"
                          />
                          Cancel
                        </div>
                        <div
                          className="mr-3 f10-500"
                          align="center"
                          onClick={props.approveClick}
                        >
                          <Image
                            src={require("../../../../../assets/images/iconButton/Nextarrowgreen.svg")}
                            alt="Validate"
                            title="Validate"
                          />
                          Approve
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </td>
                ) : null}
              </tr>
              {TrDetail && (
                <>
                  <tr
                    className="sd_accordion_body"
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                    }}
                  >
                    {parseInt(props?.promotion?.status) === 0 ? (
                      <td
                        style={{ width: "12%" }}
                        onClick={(e) => {
                          if (!e) var e = window.event;
                          e.cancelBubble = true;
                          if (e.stopPropagation) e.stopPropagation();
                        }}
                      >
                        <div className="border-right">
                          <div className="f12-400 opacity5 mb-4">
                            More Actions
                          </div>
                          <div
                            className="f12-400 d-flex"
                            onClick={(e) => {
                              if (!e) var e = window.event;
                              e.cancelBubble = true;
                              if (e.stopPropagation) e.stopPropagation();
                            }}
                          >
                            <Button
                              variant="link"
                              className="enIconBtn mr-3"
                              onClick={props.onClickDelete}
                            >
                              <Image
                                src={require("../../../../../assets/images/UserManagement/Delete.svg")}
                                alt="Delete"
                                title="Delete"
                                fluid
                              />
                            </Button>
                            {props.displayActions ? null : (
                              <EditMerchantPromotionRequest
                                editData={props?.promotion}
                              />
                            )}
                          </div>
                        </div>
                      </td>
                    ) : null}
                    <td
                      style={{ width: "10%" }}
                      onClick={(e) => {
                        if (!e) var e = window.event;
                        e.cancelBubble = true;
                        if (e.stopPropagation) e.stopPropagation();
                      }}
                    >
                      <div className="border-right">
                        <div className="f12-400 opacity5 mb-4">
                          Promotion <br />
                          Type
                        </div>

                        <div className="f12-500">
                          {props?.promotion?.permotion_type || ""}
                        </div>
                      </div>
                    </td>
                    {props.displayActions ? (
                      <td style={{ width: "10%" }}>
                        <div className="f12-400 opacity5 mb-4">Created By</div>
                        <div className="f12-500">
                          {props?.promotion?.requsted_by !== null &&
                          props?.promotion?.requsted_by !== undefined
                            ? props?.promotion?.requsted_by?.role
                            : "_"}
                        </div>
                      </td>
                    ) : null}
                    {props.displayActions ? (
                      <td style={{ width: "16%" }}>
                        <div className="border-right">
                          <div className="f12-400 opacity5 mb-4">
                            Created Date/Time
                          </div>
                          <h5 className="f12-500">
                            {props?.promotion?.requsted_date !== null &&
                            props?.promotion?.requsted_date !== undefined
                              ? moment(props?.promotion?.requsted_date).format(
                                  "Do MMM, YYYY"
                                )
                              : "_"}
                          </h5>
                          <h5 className="f12-500">
                            {props?.promotion?.requsted_date !== null &&
                            props?.promotion?.requsted_date !== undefined
                              ? moment(props?.promotion?.requsted_date).format(
                                  "hh:mm A"
                                )
                              : "_"}
                          </h5>
                        </div>
                      </td>
                    ) : null}
                    {props.displayActions ? (
                      <td style={{ width: "10%" }}>
                        <div className="f12-400 opacity5 mb-4">
                          Validated By
                        </div>
                        <h5 className="f12-500">
                          {props?.promotion?.validated_by !== null &&
                          props?.promotion?.validated_by !== undefined
                            ? props?.promotion?.validated_by?.role
                            : "_"}
                        </h5>
                      </td>
                    ) : null}
                    {props.displayActions ? (
                      <td style={{ width: "16%" }}>
                        <div className="border-right">
                          <div className="f12-400 opacity5 mb-4">
                            Validated Date/Time
                          </div>
                          <h5 className="f12-500">
                            {props?.promotion?.validated_date !== null &&
                            props?.promotion?.validated_date !== undefined
                              ? moment(props?.promotion?.validated_date).format(
                                  "Do MMM, YYYY"
                                )
                              : "_"}
                          </h5>
                          <h5 className="f12-500">
                            {props?.promotion?.validated_date !== null &&
                            props?.promotion?.validated_date !== undefined
                              ? moment(props?.promotion?.validated_date).format(
                                  "hh:mm A"
                                )
                              : "_"}
                          </h5>
                        </div>
                      </td>
                    ) : null}
                    {props.displayActions ? (
                      <td style={{ width: "10%" }}>
                        <div className="f12-400 opacity5 mb-4">Approved By</div>
                        <h5 className="f12-500">
                          {props?.promotion?.approved_by !== null &&
                          props?.promotion?.approved_by !== undefined
                            ? props?.promotion?.approved_by?.role
                            : "_"}
                        </h5>
                      </td>
                    ) : null}
                    {props.displayActions ? (
                      <td style={{ width: "16%" }}>
                        <div className="f12-400 opacity5 mb-4">
                          Approval Date/Time
                        </div>
                        <h5 className="f12-500">
                          {props?.promotion?.approved_date !== null &&
                          props?.promotion?.approved_date !== undefined
                            ? moment(props?.promotion?.approved_date).format(
                                "Do MMM, YYYY"
                              )
                            : "_"}
                        </h5>
                        <h5 className="f12-500">
                          {props?.promotion?.approved_date !== null &&
                          props?.promotion?.approved_date !== undefined
                            ? moment(props?.promotion?.approved_date).format(
                                "hh:mm A"
                              )
                            : "_"}
                        </h5>
                      </td>
                    ) : null}
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

export default PromotionTableBody;
